import * as mutationTypes from './mutation-types'

const Users = {
  state() {
    return {
      users: {},
    }
  },

  getters: {
    userById: (state) => (id) => {
      // partial remark data (without user) might exist in the store,
      // but we can still show the Remark without the name of the author.
      return state.users[id] || {}
    },
    currentUser: (state) => {
      return state.users[Silverfin.currentUserId()]
    },
  },

  mutations: {
    [mutationTypes.SET_USERS](state, users) {
      state.users = users
    },
  },
}

export default Users
